import NotificationsContext, { AppNotification } from 'contexts/notifications';
import { ReactNode, useCallback, useMemo, useState } from 'react';
import Notifications from './notifications';

const NotificationsProvider = ({ children }: { children: ReactNode }) => {
  const [notifications, setNotifications] = useState<AppNotification[]>([]);

  const addNotification = useCallback((notification: AppNotification) => {
    setNotifications(notifications => {
      if (notification.isSingular) {
        return [
          ...notifications.filter(n => n.type !== notification.type),
          notification,
        ];
      }
      return [...notifications, notification];
    });
  }, []);

  const removeNotification = useCallback((notification: AppNotification) => {
    setNotifications(notifications =>
      notifications.filter(v => v !== notification)
    );
  }, []);

  const value = useMemo(() => ({ addNotification, removeNotification }), [
    addNotification,
    removeNotification,
  ]);

  return (
    <NotificationsContext.Provider value={value}>
      <Notifications
        notifications={notifications}
        setNotifications={setNotifications}
      />

      {children}
    </NotificationsContext.Provider>
  );
};

export default NotificationsProvider;
